import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

import { DprHseDetail } from '@shared/models/dpr';
import { Sync } from '@shared/models/grid';
import { Hse } from '@shared/models/project-setup';
import { DprHseDetailGridData } from '@dpr-details/models/grid';

@Injectable()
export class DprHseGridService {
  mapToGridSync(
    changes: Sync<DprHseDetailGridData>
  ): Sync<DprHseDetailGridData> {
    const result: Sync<DprHseDetailGridData> = {
      addedList: [],
      updatedList: [],
      deletedIds: changes?.deletedIds ?? [],
    };

    result.addedList.push(...(changes?.addedList ?? [])); // needed for offline
    result.addedList.push(
      ...(changes?.updatedList?.filter((x) => isNaN(+x.id)) ?? [])
    );

    result.updatedList = changes?.updatedList?.filter((x) => !isNaN(+x.id));

    return result;
  }

  buildGridData(
    hseList: Hse[],
    dprHseDetails: DprHseDetail[],
    dprHseId: number | string
  ): DprHseDetailGridData[] {
    const data: DprHseDetailGridData[] = [];

    hseList.forEach((item) => {
      const dprHseDetail = dprHseDetails.find((d) => d.hseId === item.id);
      if (dprHseDetail) {
        data.push({
          ...dprHseDetail,
          id: dprHseDetail.id ?? uuidv4(),
          priority: item.priority,
          name: item.name,
          total: this.calculateTotal(dprHseDetail.previous, dprHseDetail.today),
          hseId: item.id,
        });
      } else {
        data.push({
          id: uuidv4(),
          dprhseId: dprHseId,
          priority: item.priority,
          name: item.name,
          previous: 0,
          today: null,
          total: 0,
          comment: null,
          hseId: item.id,
        });
      }
    });

    return data;
  }

  calculateTotal(previous: number, today: number): number {
    return previous + (today ?? 0);
  }

  shouldAutoFill(data: DprHseDetailGridData[]): boolean {
    if (!data?.length) {
      return false;
    }

    const someItemsFilled = data.some((x) => x.today != null);
    const someItemsEmpty = data.some((x) => x.today == null);

    return someItemsFilled && someItemsEmpty;
  }
}
